import {PMSResDto} from '@/models';
import moment from 'moment';

import {BoardArticle} from '@/models';
export const PMS_YYYYMMDD = 'YYYYMMDD';

export interface programCodeInfo {
  programCode: string;
  programName: string;
}

export interface ResProgramList extends PMSResDto {
  obj: any;
  items: Array<programCodeInfo>;
}

export interface programInfo {
  programCode: string;
  programName: string;
  saleStDate: string;
  saleEdDate: string;
  personDefault: number;
  personMax: number;
  promoYn: string;
  optionList: Array<programOptionInfo>;
}
export interface programOptionInfo {
  optionCode: string;
  viewName: string;
  settingType: string;
  amt: number;
  addPersonAmt: number;
  timeInfo: string;
}

export interface ResProgramInfo extends PMSResDto {
  obj: programInfo;
  items: any;
}

export interface PleisureReserv {
  reservNo: string;
  status: string;
  statusText: string;
  sourceCd: string;
  sourceCdText: string;
  programCode: string;
  programName: string;
  mOptionCode: string;
  mOptionName: string;
  sOptionCode: string;
  sOptionName: string;
  guestNo: string;
  bookName: string;
  bookHpNo: string;
  email: string;
  personCnt: number;
  reservDate: string;
  programAmt: number;
  addPersonAmt: number;
  reqDate: string;
  reqTime: string;
  bookDate: string;
  bookTime: string;
  reqMemo: string;
  totalAmt: number;
}

export interface PMS_Res_PleisureReservListItem extends PMSResDto {
  obj: any;
  items: Array<PleisureReserv>;
}
